/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { tickets as getTicketAction } from '../../actions/Tickets/ticketsActions';
import TicketItem from './TicketItem';
import Pagination from './Pagination';
import PageSpinner from '../../assets/svgs/PageSpinner';
import Toolbar from './Toolbar';

const TicketsList = ({ className, perpage }) => {
    const [isFetch, setFetch] = useState(true);
    const [ticketPage, setTicketPage] = useState(
        sessionStorage.getItem('page') ? sessionStorage.getItem('page') : 1
    );
    const [status, setStatus] = useState(
        sessionStorage.getItem('filter')
            ? sessionStorage.getItem('filter')
            : 'ByUser'
    );
    const [order, setOrder] = useState(sessionStorage.getItem('order') ?
        sessionStorage.getItem('order'): 'DESC');
    const [delay, setDelay] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const allTicketsCount = useSelector(state => state.tickets.count);
    const tickets = useSelector(state => state.tickets.all);
    const dispatch = useDispatch();

    useEffect(() => {
        setFetch(true);
        const getTickets = async () => {
            sessionStorage.setItem('page', ticketPage);
            sessionStorage.setItem('filter', status);
            const response = await dispatch(
                getTicketAction(ticketPage, perpage, status, order, searchKey)
            );
            setFetch(false);
        };
        getTickets();
    }, [ticketPage, status, order, searchKey]);

    const pageChangeHandler = page => {
        setTicketPage(page + 1);
    };

    const filterHandler = async filter => {
        // if (filter === 'reverse') {
        //     setOrder(order === 'DESC' ? 'ASC' : 'DESC');
        // }

        if (filter !== 'close') {
            if (filter === 'All') {
                setStatus(null);
            } else {
                setStatus(filter);
            }
            setTicketPage(1);
        }
    };

    const searchHandler = text => {
        if (delay) {
            clearTimeout(delay);
        }
        setDelay(
            setTimeout(() => {
                setSearchKey(text);
            }, 1500)
        );
    };

    const generateTicket = ticket => {
        const isSpam =
            !!(ticket.status === '-1' &&
            ticket.important === '0' &&
            ticket.public === '0');

        const isPrivate = ticket.public === '2';
        const isClose = ticket.status === '0';

        return (
            <TicketItem
                key={ticket.id}
                ticket={ticket}
                isSpam={isSpam}
                isPrivate={isPrivate}
                isClose={isClose}
            />
        );
    };

    return (
        <div className={className}>
            {isFetch ? (
                <div className="Loading">
                    <PageSpinner />
                </div>
            ) : (
                <>
                    <Toolbar
                        onFilterChange={filterHandler}
                        onSearch={searchHandler}
                        setOrder={setOrder}
                        order={order}
                    />
                    {tickets.map(generateTicket)}
                </>
            )}
            <Pagination
                total={allTicketsCount}
                perpage={perpage}
                onPageChange={pageChangeHandler}
                visibleCount={1}
                activePageProps={ticketPage - 1}
            />
        </div>
    );
};
TicketsList.propTypes = {
    className: PropTypes.string.isRequired,
    perpage: PropTypes.number.isRequired
};

export default styled(TicketsList)`
    height: calc(100vh - 163px);
    padding: 15px 35px;
    overflow: auto;
    overflow-x: hidden;

    ${Toolbar} {
        margin-top: 25px;
        margin-bottom: 40px;
    }

    ${Pagination} {
        margin-bottom: 60px;
    }

    .Loading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 240px);
    }
`;
